import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinSensitivity = lazyWithPreload(
  () => import('./SkinSensitivity'),
)
